<template>

    <v-loader v-if="starting" size="lg" centered />

    <div v-else>

        <v-page-filters floating>
            <v-searchbar :model="params.q" @input="params.q = $event" :action="getPages" />
            <div></div>
        </v-page-filters>

        <v-notice v-if="!pages.length" title="No Pages" message="No pages found for this customer." />

        <div v-else class="pages">
            <div v-for="page in pages" :key="page.id">
                <div v-if="dividers.includes(page.id)" class="divider">
                    <span>{{ page.last_visited_at | date('MMMM YYYY') }}</span>
                </div>
                <v-page :page="page" />
            </div>
            <div class="load-more">
                <div v-if="pagination.next_page_url">
                    <v-button class="w-200" size="sm" btn-style="white" :loading="loading" @click.native="getMorePages">Load More</v-button>
                </div>
            </div>
        </div>

    </div>

</template>

<style scoped lang="scss">

    .pages {
        display: flex;
        flex-direction: column;
        .divider {
            border-left: 1px solid $color-rule;
            padding: 5px 0 15px 0;
            text-align: center;
            span {
                @include font-medium(12px);
                color: $color-text;
                letter-spacing: 1px;
                text-transform: uppercase;
            }
        }
    }

    .load-more {
        display: flex;
        justify-content: center;
        padding: 20px 30px 30px 30px;
    }

</style>

<script>

import CustomerApi from '@api/CustomerApi';
import EventPage from './components/EventPage';
import moment from 'moment';

export default {

    components: {
        'v-page': EventPage,
    },

    data() {
        return {
            starting: true,
            loading: false,
            pages: [],
            pagination: {},
            months: [],
            dividers: [],
            params: {},
        }
    },

    mounted() {
        this.getPages();
    },

    methods: {

        getPages() {
            this.$store.commit('loading', true);
            this.params.page = 1;
            CustomerApi.getPages(this.$route.params.id, this.params)
                .then((response) => {
                    this.starting = false;
                    this.$store.commit('loading', false);
                    this.pages = response.data.data;
                    this.pagination = response.data.pagination;
                    this.makeDividers();
                }, () => {
                    this.$store.commit('loading', false);
                });
        },

        getMorePages() {
            this.loading = true;
            this.params.page = this.pagination.current_page + 1;
            CustomerApi.getPages(this.$route.params.id, this.params)
                .then((response) => {
                    this.loading = false;
                    this.pages = this.pages.concat(response.data.data);
                    this.pagination = response.data.pagination;
                    this.makeDividers();
                }, (error) => {
                    this.loading = false;
                    this.$store.commit('setAlertWithError', error);
                });
        },

        makeDividers() {
            this.months = [];
            this.dividers = [];
            this.pages.forEach((page) => {
                let date = moment.unix(page.last_visited_at).format('MMMM YYYY');
                if (!this.months.includes(date) && !this.dividers.includes(page.id)) {
                    this.months.push(date);
                    this.dividers.push(page.id);
                }
            });
        },

    }

}

</script>